import { AnyAction } from 'redux';

import { SETTINGS_REQUESTED, SETTINGS_RECEIVED, SETTINGS_RECEIVE_FAILED, SETTINGS_RECEIVE_DONE } from '@ttstr/actions';
import { StoreSettings } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  loading: boolean;
  settings: StoreSettings;
  settingsReceived: boolean;
  error: Error;
}

const initialState: ReduxState = {
  loading: false,
  settings: null,
  settingsReceived: false,
  error: null,
};

const settings = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case SETTINGS_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case SETTINGS_RECEIVED: {
      const { settings } = action.payload;

      return {
        ...state,
        settingsReceived: true,
        settings,
      };
    }
    case SETTINGS_RECEIVE_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        error,
      };
    }
    case SETTINGS_RECEIVE_DONE: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const getSettings = (state: AppState) => {
  return state.Settings.settings;
};

export const getSettingsReceived = (state: AppState) => {
  return state.Settings.settingsReceived;
};

export default settings;
